import * as React from 'react';
import React__default, { createElement, useContext, useRef, useEffect, useMemo, useCallback } from 'react';
import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import { classNames as classNames$5, EGDSContextWrapper, useEGDSContext, analyticsTracker } from '@egds/react-core/utils';
import { EGDSLayoutFlex, EGDSLayoutFlexItem } from '@egds/react-core/layout-flex';
import { EGDSLayoutGrid, EGDSLayoutGridItem, MinMax } from '@egds/react-core/layout-grid';
import { EGDSIcon, EGDSIconSize } from '@egds/react-core/icons';
import styles from '../styles/egds-lodging-step-indicator.css';
import numberFormatter from 'number-formatter';
import { useLocalization } from '@shared-ui/localization-context';
import { EGDSField } from '@egds/react-core/field';
import styles$1 from '../styles/egds-lodging-price-inputs.css';
import useForkRef from '@rooks/use-fork-ref';
import { EGDSButton, EGDSTertiaryButton } from '@egds/react-core/button';
import styles$2 from '../styles/egds-lodging-price-slider.css';
import styles$3 from '../styles/egds-lodging-slider-text-inputs.css';
import { EGDSText } from '@egds/react-core/text';
import styles$4 from '../styles/egds-lodging-text-loyalty-themes.css';
import styles$5 from '../styles/egds-lodging-icon-loyalty-themes.css';
import styles$6 from '../styles/egds-lodging-tertiary-button-large-icon-with-text.css';
import styles$7 from '../styles/egds-lodging-neutral-color-link.css';
import styles$8 from '../styles/egds-lodging-radio-button-description-extension-with-positive-theme.css';
import { EGDSBadgeLoyalty, EGDSBadgeStandard } from '@egds/react-core/badge';
import styles$9 from '../styles/egds-lodging-loyalty-badge-muted.css';
import styles$a from '../styles/egds-lodging-calendar-rates-background.css';
import { EGDSCarousel } from '@egds/react-core/carousel';
import styles$b from '../styles/egds-lodging-carousel.css';
import { EGDSCard } from '@egds/react-core/cards';
import styles$c from '../styles/egds-lodging-card.css';
import { EGDSSpacing } from '@egds/react-core/spacing';
import styles$d from '../styles/egds-lodging-coach-mark-3.css';
import { EGDSFigure, EGDSFigureAspectRatioType, EGDSImage } from '@egds/react-core/images';
import styles$e from '../styles/egds-lodging-range-indicator.css';
import { EGDSSheet, EGDSSheetTransition } from '@egds/react-core/sheet';
import { CSSTransition } from 'react-transition-group';
import styles$f from '../styles/egds-lodging-sheet.css';
import styles$g from '../styles/egds-lodging-thumbnail-card.css';
import { EGDSLayoutPosition } from '@egds/react-core/layout-position';
import { EGDSToolbar } from '@egds/react-core/toolbar';
import styles$h from '../styles/egds-lodging-toolbar.css';
import { EGDSTableRow } from '@egds/react-core/tables';
import styles$i from '../styles/egds-lodging-table-row.css';
import styles$j from '../styles/egds-lodging-images.css';
import { debounce } from 'throttle-debounce';
import styles$k from '../styles/egds-lodging-segmented-controls-2.css';

const getClassNameList$j = classNames$5.bind(styles);
const StepIndicatorItem = (props) => {
    const { active, complete, content, direction, hasLeadingAndTrailingLines, icon, isDecorativeOnly, label, labelSize, stepIndicatorSize, trackLabelA11y, } = props;
    const stepperContentClass = getClassNameList$j('step-indicator-stepper-content');
    const stepperClass = 'step-indicator-stepper';
    const stepperClasses = getClassNameList$j(stepperClass, {
        [`${stepperClass}-size-${stepIndicatorSize}`]: stepIndicatorSize,
        [`${stepperClass}-direction-${direction}`]: direction,
        [`${stepperClass}-complete`]: !isDecorativeOnly && complete,
        [`${stepperClass}-active`]: !isDecorativeOnly && active,
        [`${stepperClass}-has-leading-and-trailing`]: isDecorativeOnly && direction === 'horizontal' && hasLeadingAndTrailingLines,
    });
    const stepperMarkerClass = 'step-indicator-stepper-marker';
    const stepperMarkerClasses = getClassNameList$j(stepperMarkerClass);
    const markerCircleClass = 'step-indicator-stepper-marker-circle';
    const markerCircleClasses = getClassNameList$j(markerCircleClass, {
        [`${markerCircleClass}-size-${stepIndicatorSize}`]: stepIndicatorSize,
        [`${markerCircleClass}-has-icon`]: !isDecorativeOnly && icon,
    });
    const labelClass = 'step-indicator-stepper-label';
    const labelClasses = getClassNameList$j(labelClass, {
        [`${labelClass}-${labelSize}`]: labelSize,
    });
    const screenReaderOnlyClass = 'sr-only';
    const renderAccessibilityLabel = (accessibilityTrackLabel) => (jsx("li", { className: screenReaderOnlyClass, children: accessibilityTrackLabel }));
    return (jsxs(Fragment, { children: [jsxs("li", { className: stepperClasses, children: [jsx("div", { className: stepperMarkerClasses, children: jsx("div", { className: markerCircleClasses, children: icon && stepIndicatorSize === 'large' && jsx(EGDSIcon, { name: icon, size: EGDSIconSize.EXTRA_SMALL }) }) }), (label || content) && (jsxs("div", { className: stepperContentClass, children: [label && jsx("span", { className: labelClasses, children: label }), content && jsx("div", { children: content })] }))] }), trackLabelA11y ? renderAccessibilityLabel(trackLabelA11y) : ''] }));
};
StepIndicatorItem.defaultProps = {
    content: null,
    icon: null,
    label: null,
    trackLabelA11y: null,
};

const getClassNameList$i = classNames$5.bind(styles);
const StepIndicator = (props) => {
    const { activeStep, direction, hasLeadingAndTrailingLines, isDecorativeOnly, labelSize, stepIndicatorSize, steps, stepLength, } = props;
    const stepStyle = isDecorativeOnly ? 'decorative' : stepIndicatorSize;
    const stepIndicatorClass = 'step-indicator';
    const stepIndicatorClasses = getClassNameList$i(stepIndicatorClass, {
        [`${stepIndicatorClass}-direction-${direction}`]: direction,
        [`${stepIndicatorClass}-step-length-${stepLength}`]: stepLength,
    });
    const labelClass = 'step-indicator-stepper-label';
    const labelClasses = getClassNameList$i(labelClass, {
        [`${labelClass}-${labelSize}`]: labelSize,
    });
    const horizontalLayout = () => (jsxs(Fragment, { children: [jsx(EGDSLayoutFlex, { justifyContent: "center", children: steps.map((step, index) => {
                    if (index !== steps.length - 1) {
                        return (jsx(EGDSLayoutFlexItem, { style: { width: `${100 / steps.length}%`, textAlign: 'center' }, alignSelf: "center", children: jsx("span", { className: labelClasses, "aria-hidden": "true", children: step.trackLabelText ? step?.trackLabelText : null }) }, `horizontal-track-label-${index}`));
                    }
                    return null;
                }) }), jsx("ol", { className: stepIndicatorClasses, children: steps.map((step, index) => {
                    const active = activeStep === index + 1;
                    const complete = index + 1 < activeStep;
                    return (createElement(StepIndicatorItem, { ...step, active: active, complete: complete, direction: direction, hasLeadingAndTrailingLines: hasLeadingAndTrailingLines, isDecorativeOnly: isDecorativeOnly, labelSize: labelSize, key: step.label, stepIndicatorSize: stepStyle }));
                }) })] }));
    const verticalLayout = () => (jsxs(EGDSLayoutGrid, { columns: ['auto', 'auto'], space: "two", children: [jsx(EGDSLayoutGridItem, { children: jsx(EGDSLayoutFlex, { direction: "column", justifyContent: "center", children: steps.map((step, index) => {
                        if (index !== steps.length - 1) {
                            return (jsx(EGDSLayoutFlexItem, { alignSelf: "end", style: { height: `${100 / steps.length}%`, textAlign: 'right' }, children: jsx("span", { className: labelClasses, "aria-hidden": "true", children: step.trackLabelText ? step?.trackLabelText : null }) }, `vertical-track-label-${index}`));
                        }
                        return null;
                    }) }) }), jsx(EGDSLayoutGridItem, { children: jsx("ol", { className: stepIndicatorClasses, children: steps?.map((step, index) => {
                        const active = activeStep === index + 1;
                        const complete = index + 1 < activeStep;
                        return (createElement(StepIndicatorItem, { ...step, active: active, complete: complete, direction: direction, hasLeadingAndTrailingLines: hasLeadingAndTrailingLines, isDecorativeOnly: isDecorativeOnly, labelSize: labelSize, key: step.label, stepIndicatorSize: stepStyle }));
                    }) }) })] }));
    if (direction === 'horizontal')
        return horizontalLayout();
    return verticalLayout();
};
StepIndicator.defaultProps = {
    direction: 'horizontal',
    stepIndicatorSize: 'small',
    stepLength: 'equal',
    hasLeadingAndTrailingLines: false,
    isDecorativeOnly: false,
    labelSize: 'medium',
};

const getClassNameList$h = classNames$5.bind(styles$1);
class Input extends React.Component {
    static defaultProps = {
        hasClearButton: false,
        required: false,
        value: '',
    };
    autofillInput;
    inputRef;
    constructor(props) {
        super(props);
        this.state = {
            autofilled: false,
            mounted: false,
        };
        this.handleClear = this.handleClear.bind(this);
        this.setAutoFill = this.setAutoFill.bind(this);
        this.inputRef = props.domRef || React.createRef();
    }
    componentDidMount() {
        this.startTimer();
        this.setState({ mounted: true });
    }
    componentWillUnmount() {
        const { domRef } = this.props;
        if (domRef) {
            this.clearTimer();
        }
    }
    handleClear() {
        const { handleClear, onChange, id, name } = this.props;
        if (onChange) {
            onChange({
                target: { value: '', name: name ?? id },
            });
            // Shift focus back to input field for a11y
            this.inputRef?.current?.focus();
        }
        if (typeof handleClear === 'function') {
            handleClear();
        }
    }
    setAutoFill() {
        const curr = this.inputRef?.current;
        if (curr) {
            try {
                if (curr.matches(':autofill')) {
                    this.clearTimer();
                    this.setState({ autofilled: true });
                }
            }
            catch (error) {
                try {
                    if (curr.matches(':-webkit-autofill')) {
                        this.clearTimer();
                        this.setState({ autofilled: true });
                    }
                    // eslint-disable-next-line @typescript-eslint/no-shadow
                }
                catch (error) {
                    return false;
                }
            }
        }
    }
    startTimer() {
        // Before init setTimeout, clear the existing timer
        this.clearTimer();
        this.autofillInput = setTimeout(() => {
            this.setAutoFill();
        }, 500);
    }
    clearTimer() {
        clearTimeout(this.autofillInput);
    }
    render() {
        // Black list these props from the input field
        const { children, className, label, hasBorder, hasFloatedLabel, hasVisibleLabel, icon, instruction, invalid, l10n, hasClearButton, required, onBlur, onKeyPress, onChange, ...attributes } = this.props;
        const { placeholder, ...attrs } = attributes;
        const { id, disabled, readOnly, value } = attributes;
        const { autofilled, mounted } = this.state;
        const showClearButton = mounted && hasClearButton && value;
        const fieldPropsClassNames = getClassNameList$h(showClearButton && 'has-input-cta');
        const fieldProps = {
            labelClassName: fieldPropsClassNames,
            disabled,
            hasAutofill: autofilled,
            hasBorder,
            hasFloatedLabel,
            hasVisibleLabel,
            icon,
            id,
            instruction,
            invalid,
            label,
            placeholder,
            readOnly,
            required,
        };
        const inputExtraAttr = attrs;
        if (inputExtraAttr.domRef) {
            delete inputExtraAttr.domRef;
        }
        if (inputExtraAttr.handleClear) {
            delete inputExtraAttr.handleClear;
        }
        const cssClassNames = getClassNameList$h('uitk-field-input', showClearButton && 'has-input-cta', className, !placeholder && !value && 'empty-placeholder', 'remove-spinner');
        let ariaFieldLabel = label;
        if (React.isValidElement(label)) {
            const labelProp = label.props;
            ariaFieldLabel = labelProp && labelProp.children && labelProp.children[0];
        }
        const localizedClearText = l10n.formatText('clear');
        const iconTitle = [localizedClearText, ariaFieldLabel].join(' ');
        return (jsxs(EGDSField, { ...fieldProps, children: [jsx("input", { ...inputExtraAttr, className: cssClassNames, "aria-describedby": invalid ? `${id}-error` : undefined, placeholder: placeholder, ref: this.inputRef, id: id, "aria-required": required, "aria-invalid": !!invalid, onBlur: onBlur, onChange: onChange, onKeyPress: onKeyPress }), children, showClearButton && mounted && (jsx("button", { className: getClassNameList$h('uitk-clear-button', 'price-input-cta'), onClick: this.handleClear, type: "button", children: jsx(EGDSIcon, { name: "cancel", size: EGDSIconSize.SMALL, title: iconTitle, id: `${id}-clear-input-button` }) }))] }));
    }
}
const PriceInput = (props) => {
    const l10n = useLocalization();
    return jsx(Input, { l10n: l10n, ...props });
};

classNames$5.bind(styles$1);

class PriceTextInput extends React.Component {
    static displayName = 'PriceTextInput';
    render() {
        return jsx(PriceInput, { ...this.props, type: "text" });
    }
}

class PriceNumberInput extends React.Component {
    static displayName = 'PriceNumberInput';
    render() {
        return jsx(PriceInput, { ...this.props, type: "number" });
    }
}

classNames$5.bind(styles$1);

classNames$5.bind(styles$1);

const getClassNameList$g = classNames$5.bind(styles$1);
const ownerDocument = (node) => (node && node.ownerDocument) || document;
const ownerWindow = (node) => {
    const doc = ownerDocument(node);
    return doc.defaultView || window;
};
const getStyleValue = (computedStyle, property) => parseInt(computedStyle[property], 10) || 0;
const shadowStyles = {
    height: 0,
    left: 0,
    minHeight: 'unset',
    // Ignore the scrollbar width
    overflow: 'hidden',
    // Create a new layer, increase the isolation of the computed values
    // Remove from the content flow
    position: 'absolute',
    top: 0,
    transform: 'translateZ(0)',
    // Visibility needed to hide the extra text area on iPads
    visibility: 'hidden',
};
const useEnhancedEffect = typeof window === 'undefined' ? React.useEffect : React.useLayoutEffect;
const PriceTextArea = React.forwardRef((props, ref) => {
    const { onChange, maxRows, minRows = 2, value, className, disabled, hasBorder, hasFloatedLabel, hasVisibleLabel, id, instruction, invalid, label, placeholder, readOnly, required, domRef, ...other } = props;
    const uitkFieldProps = {
        disabled,
        hasBorder,
        hasFloatedLabel,
        hasVisibleLabel,
        id,
        instruction,
        invalid,
        label,
        placeholder,
        readOnly,
        required,
    };
    const { current: isControlled } = React.useRef(value !== null);
    const inputRef = React.useRef(null);
    // Giving priority to domRef as the forwarded ref since it is documented
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const handleRef = domRef ? useForkRef(domRef, inputRef) : useForkRef(ref, inputRef);
    const shadowRef = React.useRef(null);
    const renders = React.useRef(0);
    const [state, setState] = React.useState({});
    const textAreaClassNames = getClassNameList$g('price-field-textarea', className);
    const syncHeight = React.useCallback(() => {
        const input = inputRef.current;
        const inputShallow = shadowRef.current;
        if (input && inputShallow) {
            const containerWindow = ownerWindow(input);
            const computedStyle = containerWindow.getComputedStyle(input);
            inputShallow.value = input.value || placeholder || 'x';
            const boxSizing = computedStyle['box-sizing'];
            const padding = getStyleValue(computedStyle, 'padding-bottom') + getStyleValue(computedStyle, 'padding-top');
            const border = getStyleValue(computedStyle, 'border-bottom-width') + getStyleValue(computedStyle, 'border-top-width');
            // The height of the inner content
            const innerHeight = inputShallow.scrollHeight - padding;
            // Measure height of a textarea with a single row
            inputShallow.value = 'x';
            const singleRowHeight = inputShallow.scrollHeight - padding;
            // The height of the outer content
            let outerHeight = innerHeight;
            if (minRows) {
                outerHeight = Math.max(Number(minRows) * singleRowHeight, outerHeight);
            }
            if (maxRows) {
                outerHeight = Math.min(Number(maxRows) * singleRowHeight, outerHeight);
            }
            outerHeight = Math.max(outerHeight, singleRowHeight);
            // Take the box sizing into account for applying this value as a style.
            const outerHeightStyle = outerHeight + (boxSizing === 'border-box' ? padding + border : 0) + singleRowHeight / 2;
            const overflow = Math.abs(outerHeight - innerHeight) <= 1;
            setState((prevState) => {
                // Need a large enough difference to update the height.
                // This prevents infinite rendering loop.
                if (renders.current < 20 &&
                    ((outerHeightStyle > 0 && Math.abs((prevState.outerHeightStyle || 0) - outerHeightStyle) > 1) ||
                        prevState.overflow !== overflow)) {
                    renders.current += 1;
                    return {
                        outerHeightStyle,
                        overflow,
                    };
                }
                return prevState;
            });
        }
    }, [maxRows, minRows, placeholder]);
    useEnhancedEffect(() => {
        syncHeight();
    });
    React.useEffect(() => {
        renders.current = 0;
    }, [value]);
    const handleChange = (event) => {
        renders.current = 0;
        if (!isControlled) {
            syncHeight();
        }
        if (onChange) {
            onChange(event);
        }
    };
    return (jsxs(EGDSField, { ...uitkFieldProps, children: [jsx("textarea", { "aria-required": required, "aria-invalid": !!invalid, className: getClassNameList$g(textAreaClassNames, { [`empty-placeholder`]: !value && !placeholder }), id: id, "aria-describedby": invalid ? `${id}-error` : undefined, value: value, onChange: handleChange, placeholder: placeholder, ref: handleRef, rows: minRows, style: {
                    height: state.outerHeightStyle,
                    overflow: state.overflow ? 'hidden' : undefined,
                }, ...other }), jsx("textarea", { "aria-hidden": true, className: textAreaClassNames, placeholder: placeholder, readOnly: true, ref: shadowRef, tabIndex: -1, style: { ...shadowStyles }, "data-test-id": other['data-test-id'] ? `${other['data-test-id']}-hidden` : undefined })] }));
});
PriceTextArea.defaultProps = {
    required: false,
};
PriceTextArea.displayName = 'PriceTextArea';

classNames$5.bind(styles$1);

classNames$5.bind(styles$1);

classNames$5.bind(styles$1);

const getClassNameList$f = classNames$5.bind(styles$2);
const PriceSliderInput = React.forwardRef((props, ref) => {
    const { absoluteMax, absoluteMin, disabled, formatValueForDisplay, gap, handleAfterChange, handleChange, id, isActive, label, lowerValue, max, min, name, onActive, step, type, upperValue, value, minDistance, displayLabel = true, } = props;
    const input = React.useRef(null);
    const [mounted, setMounted] = React.useState(false);
    React.useEffect(() => {
        setMounted(true);
    }, []);
    const changeEventEmitter = (changeCb, event) => {
        // Fallbacks provided for linter
        const newMaxValue = max || absoluteMax;
        const newMinValue = min || absoluteMin;
        const innerValue = event && event.target && event.target.value;
        const parsed = (innerValue && parseInt(innerValue, 10));
        switch (type) {
            case 'primary':
                if (newMaxValue - Math.min(newMaxValue - gap, parsed) >= minDistance) {
                    changeCb(Math.min(newMaxValue - gap, parsed), newMaxValue, event);
                }
                break;
            case 'secondary':
                if (Math.max(newMinValue + gap, parsed) - newMinValue >= minDistance) {
                    changeCb(newMinValue, Math.max(newMinValue + gap, parsed), event);
                }
                break;
            default:
                changeCb(parsed);
                break;
        }
    };
    const handleChangeEvt = (event) => {
        if (typeof onActive === 'function') {
            onActive(type);
        }
        if (typeof handleChange === 'function') {
            changeEventEmitter(handleChange, event);
        }
    };
    const handleAfterChangeEvt = (event) => {
        if (typeof handleAfterChange === 'function') {
            changeEventEmitter(handleAfterChange, event);
        }
    };
    React.useImperativeHandle(ref, () => ({
        changeValue: (v) => {
            handleChangeEvt({ target: { value: v, name } });
        },
        focus: () => {
            input.current?.focus();
        },
        afterChange: (v) => {
            handleAfterChangeEvt({ target: { value: v, name } });
        },
        getValue: () => Number(input.current?.value ?? 0),
        blur: () => {
            input.current?.blur();
        },
    }), [handleChangeEvt, handleAfterChangeEvt]);
    const outputRef = React.createRef();
    let thumbPosition;
    const inputClasses = ['price-slider-input'];
    const outputClasses = ['price-slider-output'];
    const inputStyles = {};
    const sliderStyles = {};
    const componentId = `${id}-${type}`;
    // Fallbacks provided for linter
    const maxValue = max ?? absoluteMax;
    const minValue = min ?? absoluteMin;
    const newLowerValue = lowerValue ?? absoluteMin;
    const newUpperValue = upperValue ?? absoluteMax;
    const newValue = value ?? absoluteMin;
    if (isActive) {
        inputClasses.push('price-slider-input-active');
    }
    switch (type) {
        case 'primary':
            inputClasses.push('slider-primary');
            thumbPosition = 100 / ((maxValue - absoluteMin) / (newLowerValue - absoluteMin));
            if (!isFinite(thumbPosition)) {
                thumbPosition = 0;
            }
            inputStyles['--slider-primary'] = `${thumbPosition}%`;
            sliderStyles.width = `${(100 / (absoluteMax - absoluteMin)) * (newUpperValue - absoluteMin)}%`;
            break;
        case 'secondary':
            inputClasses.push('slider-secondary');
            thumbPosition = 100 - 100 / ((maxValue - minValue) / (maxValue - newUpperValue));
            if (!isFinite(thumbPosition)) {
                thumbPosition = 100;
            }
            inputStyles['--slider-secondary'] = `${thumbPosition}%`;
            sliderStyles.width = `${100 - (100 / (absoluteMax - absoluteMin)) * (newLowerValue - absoluteMin)}%`;
            break;
        default:
            inputClasses.push('slider-single', 'slider-primary');
            thumbPosition = 100 / ((maxValue - minValue) / (newValue - minValue));
            if (!isFinite(thumbPosition)) {
                thumbPosition = 0;
            }
            inputStyles['--slider-primary'] = `${thumbPosition}%`;
            sliderStyles.width = '100%';
            break;
    }
    const valueToDisplay = typeof formatValueForDisplay === 'function' ? formatValueForDisplay(newValue) : newValue;
    const baseInputAttrs = {
        'aria-label': label || name,
        'aria-valuetext': `${valueToDisplay}`,
        className: getClassNameList$f(inputClasses),
        disabled,
        id: componentId,
        max: maxValue,
        min: minValue,
        name,
        onChange: handleChangeEvt,
        onKeyUp: handleAfterChangeEvt,
        onMouseUp: handleAfterChangeEvt,
        onTouchEnd: handleAfterChangeEvt,
        step,
        style: inputStyles,
    };
    return (jsxs(Fragment, { children: [jsxs("div", { className: getClassNameList$f('price-slider'), style: sliderStyles, children: [mounted ? (jsx("input", { type: "range", ref: input, "aria-valuemax": maxValue, "aria-valuemin": minValue, "aria-valuenow": newValue, value: newValue, ...baseInputAttrs })) : (
                    // eslint-disable-next-line jsx-a11y/role-supports-aria-props
                    jsx("input", { type: "number", ref: input, "aria-valuemax": maxValue, "aria-valuemin": minValue, "aria-valuenow": newValue, value: newValue, ...baseInputAttrs })), jsx("label", { className: "is-hidden", htmlFor: componentId, children: label || name })] }), displayLabel && (jsx("span", { className: getClassNameList$f(outputClasses), ref: outputRef, "aria-hidden": "true", children: valueToDisplay }))] }));
});
PriceSliderInput.displayName = 'PriceSliderInput';

const HistogramBar = ({ bucketIndex, height, inSliderRange, bucketWidth }) => {
    return (
    //if we use rect <svg> tag instead of div
    // we shouldn't need an axis component
    jsx("rect", { className: "histogram-bar", x: bucketIndex, y: 100 - height, width: bucketWidth, height: height, rx: 4, 
        //this will update with bars shading
        fill: inSliderRange ? '#649DF2' : '#9C9C9C' }));
};

const Histogram = ({ data, minPrice, maxPrice, lowerValue, upperValue }) => {
    const bucketCount = data.length;
    const ref = React.useRef(null);
    const [parentWidth, setParentWidth] = React.useState(0);
    const bucketWidth = 8;
    const histogramHeight = 98;
    React.useLayoutEffect(() => {
        const histogramElement = ref.current;
        const parent = histogramElement?.parentElement;
        if (!parent) {
            return;
        }
        const newParentWidth = parent.offsetWidth;
        setParentWidth(prev => (prev !== newParentWidth ? newParentWidth : prev));
    }, []);
    const distanceBetweenBars = (parentWidth - bucketWidth * bucketCount) / bucketCount;
    // Should attach this to a use effect becuase
    // bucket count is dynamic
    const bucketSize = (maxPrice - minPrice) / bucketCount;
    // Need to find the highest bucket, since that determines the y axis
    const maxCount = Math.max(...data);
    // Turn bucket count into bucket height
    const getBarHeight = (count) => (count / maxCount) * histogramHeight;
    return (jsx("svg", { ref: ref, className: "histogram", id: "histogram", width: parentWidth, height: histogramHeight, children: data.slice(0, bucketCount).map((count, index) => {
            const barMin = minPrice + index * bucketSize;
            const barMax = minPrice + (index + 1) * bucketSize;
            const bucketIndex = index * bucketWidth + (index > 0 ? index * distanceBetweenBars : 0) + bucketWidth / 2;
            // Check if bucket is in user inputted price range
            const inSliderRange = barMin >= lowerValue && barMax <= upperValue;
            return (jsx("svg", { children: jsx(HistogramBar, { bucketIndex: bucketIndex, height: getBarHeight(count), inSliderRange: inSliderRange, bucketWidth: bucketWidth }, index) }, index));
        }) }));
};

const getClassNameList$e = classNames$5.bind(styles$2);
// https://github.com/tmcw-up-for-adoption/simple-linear-scale/blob/master/index.js
const linearScale = (input, output) => (value) => {
    if (input[0] === input[1] || output[0] === output[1])
        return output[0];
    const ratio = (output[1] - output[0]) / (input[1] - input[0]);
    return output[0] + ratio * (value - input[0]);
};
const PriceSlider = (props) => {
    const { disabled, formatSecondaryValueForDisplay, formatValueForDisplay, gap, handleAfterChange, handleChange, lowerValue, max, min, name, primaryLabel, secondaryLabel, step, ticks, type, upperValue, value, minDistance = 0, displayLabel, 
    // histogram prop
    priceHistogramData, } = props;
    const [active, setActive] = React.useState('');
    const [isFirefoxFallback, setIsFirefoxFallback] = React.useState(false);
    const [gapWidth, setGapWidth] = React.useState(0);
    const [mounted, setMounted] = React.useState(false);
    const sliderRef = React.useRef(null);
    const tracker = React.useRef(null);
    const lowerInputRef = React.useRef(null);
    const upperInputRef = React.useRef(null);
    const currentInput = React.useRef(null);
    const isDual = isFirefoxFallback ? false : type === 'dual';
    const checkSliderWidth = () => {
        const newGap = gap || 0;
        const ref = sliderRef && sliderRef.current;
        const width = ref && ref.offsetWidth;
        if (width) {
            setGapWidth(Math.floor(((max - min) * newGap) / width));
        }
    };
    const checkFFBrowserFallback = () => {
        // eslint-disable-next-line no-negated-condition
        setIsFirefoxFallback(typeof window !== 'undefined' ? /Firefox\//.test(window.navigator.userAgent) : false);
    };
    React.useEffect(() => {
        setMounted(true);
        if (type === 'dual') {
            checkSliderWidth();
            checkFFBrowserFallback();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const handleChangeEvt = (primary, secondary, event) => {
        handleChange(primary, secondary, event);
    };
    const handleAfterChangeEvt = (primary, secondary, event) => {
        if (typeof handleAfterChange === 'function') {
            handleAfterChange(primary, secondary, event);
        }
    };
    const onActive = () => {
        if (typeof type !== 'undefined')
            setActive(type);
    };
    const getDisabled = () => !mounted || disabled;
    const trackPointer = (e) => {
        const containerBoundedRect = sliderRef.current.getBoundingClientRect();
        const isInBounds = e.clientX > containerBoundedRect.left && e.clientX < containerBoundedRect.right;
        let boundedPosition = e.clientX - containerBoundedRect.left;
        if (!isInBounds) {
            const isOutFromLeft = e.clientX < containerBoundedRect.left;
            boundedPosition = isOutFromLeft ? 0 : containerBoundedRect.width;
        }
        const scale = linearScale([0, sliderRef.current.offsetWidth], [min, max]);
        const scaledValue = scale(boundedPosition);
        const isLowerClosest = Math.abs(scaledValue - lowerValue) < Math.abs(scaledValue - upperValue);
        currentInput.current = isLowerClosest ? lowerInputRef.current : upperInputRef.current;
        const constrainedValue = Math.min(Math.max(scaledValue, min), max);
        currentInput.current?.focus();
        currentInput.current?.changeValue(constrainedValue);
    };
    const handlePointerDown = (e) => {
        e.preventDefault();
        tracker.current.setPointerCapture(e.pointerId);
        trackPointer(e);
    };
    const handlePointerMove = (e) => {
        const target = e.target;
        if (target.hasPointerCapture(e.pointerId)) {
            trackPointer(e);
        }
    };
    const handlePointerUp = (e) => {
        tracker.current.releasePointerCapture(e.pointerId);
        currentInput.current.afterChange(currentInput.current.getValue());
        currentInput.current.blur();
        currentInput.current = null;
    };
    const fieldClasses = ['price-slider-container', ...(ticks ? ['price-slider-container-has-ticks'] : [])];
    const formatSecondaryValueForDualSlider = typeof formatSecondaryValueForDisplay === 'function' ? formatSecondaryValueForDisplay : formatValueForDisplay;
    const cssStyles = {
        '--min': min,
        '--max': max,
        '--step': step,
    };
    if (getDisabled()) {
        fieldClasses.push('price-slider-container-disabled');
    }
    if (step === undefined) {
        fieldClasses.push('price-slider-container-no-step');
    }
    return (jsxs(Fragment, { children: [priceHistogramData ? (jsx("div", { className: "histogram", children: jsx(Histogram, { data: priceHistogramData, minPrice: min, maxPrice: max, upperValue: upperValue, lowerValue: lowerValue }) })) : null, jsxs("div", { "data-testid": "price-slider-container", className: getClassNameList$e(fieldClasses), ref: sliderRef, style: cssStyles, children: [type === 'dual' && isFirefoxFallback && jsx("input", { type: "hidden", value: lowerValue, name: name }), jsx(PriceSliderInput, { ...props, type: isDual ? 'primary' : 'single', name: name, max: isDual ? upperValue : max, value: isDual ? lowerValue : value || upperValue, absoluteMax: max, absoluteMin: min, gap: gapWidth, isActive: active === 'primary', onActive: onActive, disabled: getDisabled(), handleChange: handleChangeEvt, handleAfterChange: handleAfterChangeEvt, formatValueForDisplay: formatValueForDisplay, label: isDual ? primaryLabel : undefined, minDistance: minDistance, displayLabel: displayLabel, ref: lowerInputRef }), isDual && (jsx(PriceSliderInput, { ...props, type: "secondary", name: name, ref: upperInputRef, min: lowerValue, value: upperValue, absoluteMax: max, absoluteMin: min, gap: gapWidth, isActive: active === 'secondary', onActive: onActive, disabled: getDisabled(), handleChange: handleChangeEvt, handleAfterChange: handleAfterChangeEvt, formatValueForDisplay: formatSecondaryValueForDualSlider, label: secondaryLabel, minDistance: minDistance, displayLabel: displayLabel })), isDual && (jsx("div", { "aria-hidden": "true", className: getClassNameList$e('price-slider-tracker'), "data-testid": "price-slider-tracker", ref: tracker, onPointerDown: handlePointerDown, onPointerMove: handlePointerMove, onPointerUp: handlePointerUp }))] })] }));
};
PriceSlider.displayName = 'PriceSlider';

const getClassNameList$d = classNames$5.bind(styles$3);
// Process a path to retrieve an attribute from an object
const _getAttributeFromObjectWithPath = (object, path) => path.split('.').reduce((previousValue, currentKey) => previousValue?.[currentKey], object);
const _generateAriaLabel = (valueAccesibility, properties, boundAccessibility, type) => {
    const { template, models } = valueAccesibility;
    const firstLabel = boundAccessibility ||
        models.reduce((resolvedTemplate, { key, source }) => {
            const value = _getAttributeFromObjectWithPath(properties, source);
            return resolvedTemplate.replace(`{${key}}`, value);
        }, template);
    return `${firstLabel}, ${valueAccesibility.text}, ${type}`;
};
const SliderTextInputs = (props) => {
    const { fieldId, minValueInput, maxValueInput, range, minValueAccessibility, maxValueAccessibility, numberFormat, shouldShowSeperator, rangeSliderId, lowerBoundAccessibility, upperBoundAccessibility, onMinChange, onMaxChange, onRangeChange, onRangeAfterChange, resetFilters, type, allowUserMax, loading, 
    // histogram prop
    priceHistogramData, } = props;
    const { value: minValue, label: minLabel } = minValueInput;
    const { value: maxValue, label: maxLabel } = maxValueInput;
    const { characteristics, selected } = range;
    const { min: lowerBound, max: upperBound, minLabel: formattedLowerBoundValue, maxLabel: formattedUpperBoundValue, } = characteristics;
    const { step } = characteristics;
    const { min: currentSliderMin, max: currentSliderMax, id: rangeId } = selected;
    const [min, setMin] = React__default.useState(currentSliderMin);
    const [max, setMax] = React__default.useState(currentSliderMax);
    const [formattedMin, setFormattedMin] = React__default.useState(minValue);
    const [formattedMax, setFormattedMax] = React__default.useState(maxValue);
    const [basicMinimumSliderValue, setBasicMinimumSliderValue] = React__default.useState(currentSliderMin);
    const [basicMaximumSliderValue, setBasicMaximumSliderValue] = React__default.useState(currentSliderMax);
    const [userUpperBound, setUserUpperBound] = React__default.useState(basicMaximumSliderValue);
    const minAriaLabel = React__default.useMemo(() => {
        const args = { ...props, range: { characteristics, selected: { id: rangeId, min, max } } };
        return _generateAriaLabel(minValueAccessibility, args, min === lowerBound ? lowerBoundAccessibility : '', type);
    }, [min]);
    const maxAriaLabel = React__default.useMemo(() => {
        const args = { ...props, range: { characteristics, selected: { id: rangeId, min, max } } };
        return _generateAriaLabel(maxValueAccessibility, args, max === upperBound ? upperBoundAccessibility : '', type);
    }, [max]);
    const checkFFBrowserFallback = () => 
    // eslint-disable-next-line no-negated-condition
    typeof window !== 'undefined' ? /Firefox\//.test(window.navigator.userAgent) : false;
    // Hide range slider when user is in firefox
    const isFirefoxFallback = !checkFFBrowserFallback();
    /** Accept formatting string and reformat the passed value */
    const formatInputUsingFormatString = (input) => {
        if (input === lowerBound) {
            return formattedLowerBoundValue;
        }
        if (input === upperBound) {
            return formattedUpperBoundValue;
        }
        if (numberFormat) {
            return numberFormatter(numberFormat, input);
        }
        return input;
    };
    React__default.useEffect(() => {
        setMin(currentSliderMin);
        setMax(currentSliderMax);
    }, [selected]);
    React__default.useEffect(() => {
        if (resetFilters) {
            setMin(lowerBound);
            setMax(upperBound);
            setFormattedMin(formattedLowerBoundValue);
            setFormattedMax(formattedUpperBoundValue);
            setBasicMinimumSliderValue(lowerBound);
            setBasicMaximumSliderValue(upperBound);
            setUserUpperBound(upperBound);
        }
    }, [resetFilters]);
    React__default.useEffect(() => {
        if (min < max) {
            setFormattedMin(formatInputUsingFormatString(min));
            setFormattedMax(formatInputUsingFormatString(max));
            setBasicMinimumSliderValue(min);
            setBasicMaximumSliderValue(max);
        }
    }, [min, max]);
    /** Handle the blur event for minimum input text box */
    const handleBlurForMinimumInput = (event) => {
        const newInput = event.target.value;
        const parsedInput = parseInt(newInput, 10);
        const shouldRevertValue = Number.isNaN(parsedInput) || parsedInput === min || newInput === '' || parsedInput >= max;
        if (shouldRevertValue) {
            setFormattedMin(formatInputUsingFormatString(min));
        }
        else {
            setMin(parseInt(newInput, 10));
            onMinChange?.(event, parseInt(newInput, 10), max);
        }
    };
    /** Handle the blur event for maximum input text box */
    const handleBlurForMaximumInput = (event) => {
        let newInput = event.target.value;
        const parsedInput = parseInt(newInput, 10);
        const shouldRevertValue = Number.isNaN(parsedInput) ||
            (!allowUserMax && parsedInput > upperBound) ||
            newInput === '' ||
            parsedInput <= min ||
            parsedInput > 10000000;
        if (shouldRevertValue) {
            newInput = basicMaximumSliderValue.toString();
            setFormattedMax(formatInputUsingFormatString(max));
        }
        else {
            setMax(parseInt(newInput, 10));
            onMaxChange?.(event, min, parseInt(newInput, 10));
            if (allowUserMax) {
                setBasicMaximumSliderValue(parsedInput);
                setUserUpperBound(parsedInput);
            }
        }
    };
    /** Handle the change event for minimum input text box */
    const handleMinimumInputChange = (event) => {
        const newInput = event.target.value;
        setFormattedMin(newInput);
    };
    /** Handle the change event for maximum input text box */
    const handleMaximumInputChange = (event) => {
        const newInput = event.target.value;
        setFormattedMax(newInput);
    };
    /** Handle the change event for range slider input */
    const handleBasicDualSliderChange = (lowerVal, upperVal) => {
        /* istanbul ignore next */
        if (upperVal) {
            setMin(lowerVal);
            if (allowUserMax) {
                setMax(upperVal);
            }
            else {
                setMax(upperVal <= upperBound ? upperVal : lowerBound);
            }
            onRangeChange?.(lowerVal, upperVal);
        }
        else {
            setMin(lowerVal);
            onRangeChange?.(lowerVal, null);
        }
    };
    const handleAfterSliderChange = (lowerVal, upperVal, event) => {
        onRangeAfterChange?.(event, lowerVal, upperVal);
    };
    /** Remove value for focused elements */
    const handleMinFocus = () => {
        setFormattedMin('');
    };
    const handleMaxFocus = () => {
        setFormattedMax('');
    };
    /** Handle the key press event to watch for users pressing enter to submit a number input */
    const handleKeyPress = (event) => {
        const { code } = event;
        const { key } = event;
        if (event.key === 'Enter' || parseInt(event.key, 10) === 13 || parseInt(event.key, 10) === 10) {
            event.currentTarget.blur();
        }
        // Fix firefox number input issue that allow letters
        if (Number(code) < 48 || Number(code) > 57) {
            event.preventDefault();
        }
        // Prevents users from inputting anything except for numbers
        if (!(Number(key) >= 0) && !(Number(key) <= 9)) {
            event.preventDefault();
        }
    };
    const columns = shouldShowSeperator ? ['2fr', '0', '2fr'] : ['2fr', '2fr'];
    const space = shouldShowSeperator ? { column: 'four' } : { column: 'two' };
    /* eslint-disable no-negated-condition */
    const inputContainerClassName = getClassNameList$d(!isFirefoxFallback ? 'slider-text-input--input_container--firefox' : 'slider-text-input--input_container');
    const mainContainerClassName = getClassNameList$d('slider-text-input--container');
    const separatorClassName = getClassNameList$d('separator');
    const sliderClassName = getClassNameList$d('slider-text-input--slider');
    const histogramSliderClassName = getClassNameList$d('slider-text-input-histogram--slider');
    return (jsxs("div", { className: mainContainerClassName, children: [jsx("div", { className: inputContainerClassName, children: jsxs(EGDSLayoutGrid, { columns: columns, space: space, justifyContent: "space-between", children: [jsx(EGDSLayoutGridItem, { children: jsx(PriceTextInput, { "aria-label": minAriaLabel, id: `${fieldId}-min`, label: minLabel, hasFloatedLabel: false, hasVisibleLabel: true, onBlur: handleBlurForMinimumInput, onChange: handleMinimumInputChange, onFocus: handleMinFocus, value: formattedMin, onKeyPress: handleKeyPress, disabled: loading }) }), jsx(EGDSLayoutGridItem, { alignSelf: "center", justifySelf: "center", children: shouldShowSeperator && jsx("div", { className: separatorClassName }) }), jsx(EGDSLayoutGridItem, { children: jsx(PriceTextInput, { "aria-label": maxAriaLabel, id: `${fieldId}-max`, label: maxLabel, hasFloatedLabel: false, hasVisibleLabel: true, onBlur: handleBlurForMaximumInput, onChange: handleMaximumInputChange, onFocus: handleMaxFocus, value: formattedMax, onKeyPress: handleKeyPress, disabled: loading }) })] }) }), isFirefoxFallback && (jsx("div", { className: priceHistogramData ? histogramSliderClassName : sliderClassName, children: jsx(PriceSlider, { id: rangeSliderId, name: fieldId, type: "dual", min: lowerBound, max: allowUserMax ? Math.max(upperBound, userUpperBound) : upperBound, step: step, handleChange: handleBasicDualSliderChange, handleAfterChange: handleAfterSliderChange, lowerValue: basicMinimumSliderValue, upperValue: basicMaximumSliderValue, primaryLabel: minAriaLabel, secondaryLabel: maxAriaLabel, displayLabel: false, priceHistogramData: priceHistogramData }) }))] }));
};
SliderTextInputs.defaultProps = {
    numberFormat: null,
    minValueAccessibility: null,
    maxValueAccessibility: null,
    shouldShowSeperator: false,
    rangeSliderId: null,
    lowerBoundAccessibility: null,
    upperBoundAccessibility: null,
    resetFilters: false,
};

const EGDSTextLoyaltyThemes = {
    LOW: 'lowtier',
    MID: 'midtier',
    HIGH: 'hightier',
    EXTRAHIGH: 'extrahightier',
    VIP: 'vip',
};

const getClassNameList$c = classNames$5.bind(styles$4);
const TextLoyaltyThemes = (props) => {
    const { children, align, dataTestId, wordBreak, theme, className, whiteSpace, weight, size, hyphens, overflow, spacing, inline, } = props;
    const textLoyaltyClassname = getClassNameList$c(`uitk-text-loyalty-${theme}`, className);
    const isLoyaltyTheme = theme &&
        (theme === EGDSTextLoyaltyThemes.LOW ||
            theme === EGDSTextLoyaltyThemes.HIGH ||
            theme === EGDSTextLoyaltyThemes.MID ||
            theme === EGDSTextLoyaltyThemes.EXTRAHIGH);
    return (jsx(EGDSText, { className: textLoyaltyClassname, align: align, dataTestId: dataTestId, wordBreak: wordBreak, whiteSpace: whiteSpace, weight: weight, size: size, hyphens: hyphens, overflow: overflow, spacing: spacing, inline: inline, theme: isLoyaltyTheme ? 'default' : theme, children: children }));
};
TextLoyaltyThemes.displayName = 'TextLoyaltyThemes';

const EGDSIconLoyaltyThemes = {
    LOW: 'lowtier',
    MID: 'midtier',
    HIGH: 'hightier',
    EXTRAHIGH: 'extrahightier',
    VIP: 'vip',
};

const getClassNameList$b = classNames$5.bind(styles$5);
const IconLoyaltyThemes = (props) => {
    const { className, description, getMarkerPopup, id, name, shadow, spotlight, size, theme, title } = props;
    const iconLoyaltyClassname = getClassNameList$b(`uitk-icon-loyalty-${theme}`, className);
    const isLoyaltyTheme = theme &&
        theme ===
            (EGDSIconLoyaltyThemes.LOW ||
                EGDSIconLoyaltyThemes.HIGH ||
                EGDSIconLoyaltyThemes.MID ||
                EGDSIconLoyaltyThemes.EXTRAHIGH);
    return (jsx(EGDSIcon, { className: iconLoyaltyClassname, description: description, getMarkerPopup: getMarkerPopup, id: id, name: name, shadow: shadow, spotlight: spotlight, size: size, theme: isLoyaltyTheme ? 'default' : theme, title: title }));
};
IconLoyaltyThemes.displayName = 'IconLoyaltyThemes';

const getClassNameList$a = classNames$5.bind(styles$6);
const TertiaryButtonLargeIcon = (props) => {
    const { className, largeIcon, ...remaining } = props;
    const cssClassNames = getClassNameList$a(largeIcon ? `${EGDSButton.baseClassName}-tertiary-large-icon` : null, className);
    return (jsx(EGDSContextWrapper, { children: (context) => jsx(EGDSTertiaryButton, { ...remaining, className: cssClassNames, "data-context": context }) }));
};
TertiaryButtonLargeIcon.displayName = 'TertiaryButtonLargeIcon';

const EGDSLocalNeutralColorLinkThemeMap = [
    ['default', 'default'],
    ['inverse', 'inverse'],
];
const EGDSLocalNeutralColorLinkThemes = new Map(EGDSLocalNeutralColorLinkThemeMap);
const EGDSLocalNeutralColorLinkSizeMap = [
    ['small', 'small'],
    ['medium', 'medium'],
    ['large', 'large'],
];
const EGDSLocalNeutralColorLinkSizes = new Map(EGDSLocalNeutralColorLinkSizeMap);
const EGDSLocalNeutralColorLinkAlignMap = [
    ['left', 'left'],
    ['center', 'center'],
    ['right', 'right'],
];
const EGDSLocalNeutralColorLinkAligns = new Map(EGDSLocalNeutralColorLinkAlignMap);

/* eslint-disable no-useless-computed-key */
const getClassNameList$9 = classNames$5.bind(styles$7);
const EGDSLocalNeutralColorLink = (props) => {
    const { children, className, align = EGDSLocalNeutralColorLinkAligns.get('left'), theme = EGDSLocalNeutralColorLinkThemes.get('default'), inline = false, noWrap = false, analytics, size = EGDSLocalNeutralColorLinkSizes.get('medium'), disabled, domRef, ...attributes } = props;
    const { data: contextData } = useEGDSContext();
    const { contextClassNames } = contextData ?? {};
    const childrenArray = React.Children.toArray(children);
    const firstChild = childrenArray[0];
    const childClassName = getClassNameList$9('neutral-color-link', contextClassNames?.Link, className, {
        [`neutral-color-link-align-${align}`]: align,
        ['neutral-color-link-theme-inverse']: theme === 'inverse',
        ['neutral-color-link-no-wrap']: noWrap,
        ['neutral-color-link-layout-inline']: inline,
        ['neutral-color-link-layout-default']: !inline,
        [`neutral-color-link-${size}`]: size && EGDSLocalNeutralColorLinkSizes.get(size),
        ['neutral-color-link-disabled']: !!disabled,
    });
    const linkChildren = firstChild.props.children;
    const linkIconClassName = getClassNameList$9(`neutral-color-link-icon-${size}`, {
        ['neutral-color-link-inverse-icon']: theme === 'inverse',
    });
    const newChildren = [];
    const isButton = firstChild?.type === 'button';
    const disabledButton = disabled && isButton;
    React.Children.map(linkChildren, (child) => {
        if (child?.type?.displayName === 'EGDSIcon') {
            newChildren.push(React.cloneElement(child, {
                className: getClassNameList$9(linkIconClassName),
            }));
        }
        else {
            newChildren.push(child);
        }
    });
    const clickCaptureCallback = React.useCallback(() => {
        if (analytics) {
            return analyticsTracker(analytics);
        }
    }, [analytics]);
    const onClickCapture = firstChild.props.onClickCapture || props.onClickCapture || clickCaptureCallback;
    const decoratedChild = React.cloneElement(firstChild, {
        analytics,
        children: newChildren,
        ref: domRef,
        className: childClassName,
        ...attributes,
        onClickCapture,
        ...(disabledButton && {
            tabIndex: -1,
            disabled: true,
        }),
        ...(!isButton && {
            role: 'link',
            'aria-disabled': disabled || undefined, // 'undefined' fixes cursor bug
        }),
    });
    return decoratedChild;
};
EGDSLocalNeutralColorLink.displayName = 'EGDSLocalNeutralColorLink';

const RadioButtonDescriptionExtensionWithPositiveThemeGroupContext = React.createContext(null);

const getClassNameList$8 = classNames$5.bind(styles$8);
var TextTheme;
(function (TextTheme) {
    TextTheme["EMPHASIS"] = "EMPHASIS";
    TextTheme["INVERSE"] = "INVERSE";
    TextTheme["LOYALTY"] = "LOYALTY";
    TextTheme["NEGATIVE"] = "NEGATIVE";
    TextTheme["POSITIVE"] = "POSITIVE";
    TextTheme["PRIMARY"] = "PRIMARY";
    TextTheme["SECONDARY"] = "SECONDARY";
})(TextTheme || (TextTheme = {}));
const textThemeMapper = {
    [TextTheme.EMPHASIS]: 'emphasis',
    [TextTheme.LOYALTY]: 'loyalty',
    [TextTheme.INVERSE]: 'inverse',
    [TextTheme.NEGATIVE]: 'negative',
    [TextTheme.POSITIVE]: 'positive',
    [TextTheme.PRIMARY]: 'emphasis',
    [TextTheme.SECONDARY]: 'default',
};
var TextWeight;
(function (TextWeight) {
    TextWeight["BOLD"] = "BOLD";
    TextWeight["MEDIUM"] = "MEDIUM";
    TextWeight["REGULAR"] = "REGULAR";
})(TextWeight || (TextWeight = {}));
const textWeightMapper = {
    [TextWeight.BOLD]: 'bold',
    [TextWeight.MEDIUM]: 'medium',
    [TextWeight.REGULAR]: 'regular',
};
const RadioButtonDescriptionExtensionWithPositiveTheme = (props) => {
    let useReducedMotion = false;
    if (typeof window !== 'undefined') {
        useReducedMotion = window.matchMedia(`(prefers-reduced-motion: reduce)`).matches;
    }
    const { className, children, checked, description, descriptionList, disabled, id, label, labelClassName, labelSuffix, required, name, value, a11yLabel, onChange, } = props;
    const RadioButtonGroupContext = useContext(RadioButtonDescriptionExtensionWithPositiveThemeGroupContext);
    const baseCssClass = 'uitk-radio-button';
    const CssClassNameLabelSuffix = `${baseCssClass}-label-haslabelsuffix`;
    const wrapperClassNames = getClassNameList$8(baseCssClass, {
        'is-disabled': disabled,
    });
    const labelCssClassNames = getClassNameList$8(`uitk-radio-button-label`, CssClassNameLabelSuffix, {
        [labelClassName]: Boolean(labelClassName),
        'is-required': required,
    });
    const inputClassNames = getClassNameList$8({
        checked,
    }, className);
    const checkedProp = RadioButtonGroupContext?.defaultChecked ? 'defaultChecked' : 'checked';
    const isChecked = checked || RadioButtonGroupContext?.selected === value;
    const controlClassNames = getClassNameList$8(`${baseCssClass}-control`);
    const reducedMotionClassNames = getClassNameList$8(`${baseCssClass}-has-reduced-motion`);
    const { data: contextData } = useEGDSContext();
    const { hasRequiredFieldIndicator } = contextData ?? {};
    const randomId = React.useMemo(() => Math.random().toString(36).substring(7), []);
    const uniqueDescriptionId = `radio-button-description-${randomId}`;
    const descriptionA11yContent = description || descriptionList?.reduce((acc, item) => `${acc}${item.accessibility || item.text}. `, '') || '';
    const a11yFullLabel = a11yLabel && [a11yLabel, labelSuffix].filter(Boolean).join(', ').concat('.');
    return (jsx(EGDSLayoutFlex, { className: wrapperClassNames, wrap: "nowrap", children: jsx(EGDSLayoutFlexItem, { className: getClassNameList$8(`${baseCssClass}-content`), grow: 1, children: jsx("div", { children: jsxs("label", { className: labelCssClassNames, htmlFor: id, children: [jsx("input", { type: "radio", name: name || RadioButtonGroupContext?.group, id: id, [checkedProp]: isChecked, className: inputClassNames, onChange: onChange || RadioButtonGroupContext?.onChange, value: value, disabled: disabled, "aria-label": a11yFullLabel, "aria-describedby": uniqueDescriptionId }), jsx("span", { "aria-hidden": "true", className: useReducedMotion ? `${controlClassNames} ${reducedMotionClassNames}` : controlClassNames }), jsxs("div", { "aria-hidden": Boolean(a11yLabel && label), className: getClassNameList$8(`${baseCssClass}-label-content`), children: [label || children, required && hasRequiredFieldIndicator && (jsxs("span", { className: "uitk-radio-button-required-asterisk", "aria-hidden": "true", children: [' ', "*"] }))] }), labelSuffix && (jsx("span", { "aria-hidden": Boolean(a11yLabel), className: getClassNameList$8(`${baseCssClass}-label-suffix`), children: labelSuffix })), descriptionA11yContent && (jsx("span", { className: "is-hidden", id: uniqueDescriptionId, children: descriptionA11yContent })), description && (jsx("span", { "aria-hidden": Boolean(a11yLabel), className: getClassNameList$8(`${baseCssClass}-description uitk-type-200`), children: description })), descriptionList && descriptionList.length > 0 && (jsx("div", { "aria-hidden": Boolean(a11yLabel), className: getClassNameList$8(`${baseCssClass}-descriptions-container`), children: descriptionList?.map((descriptionListItem, index) => (jsx(EGDSText, { className: getClassNameList$8(`${baseCssClass}-description-list-item uitk-type-200`), theme: textThemeMapper[descriptionListItem?.theme || TextTheme.SECONDARY], weight: textWeightMapper[descriptionListItem?.weight || TextWeight.REGULAR], children: descriptionListItem.text }, `radio-button-description-${index}`))) }))] }) }) }) }));
};

const getClassNameList$7 = classNames$5.bind(styles$8);
const RadioButtonDescriptionExtensionWithPositiveThemeGroup = (props) => {
    const { children, className, defaultChecked, errorMessage, group, legendLabel, selected, onChange } = props;
    const wrapperClassNames = getClassNameList$7('uitk-radio-button-group', className);
    const errorClassNames = getClassNameList$7('uitk-radio-button-error');
    const { data: contextData } = useEGDSContext();
    const { hasRequiredFieldIndicator, collapsed, srMessage } = contextData ?? {};
    const providerValues = { onChange, defaultChecked, group, selected, hasRequiredFieldIndicator };
    const value = React.useMemo(() => ({
        ...providerValues,
    }), [providerValues]);
    const randomId = React.useMemo(() => Math.random().toString(36).substring(7), []);
    const uniqueLegendId = `legend-${randomId}`;
    return (jsxs("fieldset", { className: wrapperClassNames, "aria-labelledby": uniqueLegendId, children: [jsxs("legend", { className: "is-hidden", id: uniqueLegendId, children: [legendLabel || group, collapsed && (srMessage ? `. ${srMessage}` : '')] }), errorMessage && jsx("p", { className: errorClassNames, children: errorMessage }), jsx(RadioButtonDescriptionExtensionWithPositiveThemeGroupContext.Provider, { value: value, children: children })] }));
};

classNames$5.bind(styles$9);
const LoyaltyBadgeMuted = (props) => {
    const { theme } = props;
    return jsx(EGDSBadgeLoyalty, { ...props, className: `${theme}-muted` });
};
LoyaltyBadgeMuted.displayName = 'LoyaltyBadgeMuted';

const CalendarRatesBackgroundThemesMap = [
    ['default', 'calendar-rates-background-default'],
    ['positive', 'calendar-rates-background-positive'],
    ['negative', 'calendar-rates-background-negative'],
    ['neutral', 'calendar-rates-background-neutral'],
];
const CalendarRatesBackgroundThemes = new Map(CalendarRatesBackgroundThemesMap);

const getClassNameList$6 = classNames$5.bind(styles$a);
/**
 * CalendarRatesBackground is used as a background layer within day cells.
 * It should stretch to fill the entire area of its cell, sitting on a layer below all other day template content.
 */
const CalendarRatesBackground = (props) => {
    const { children, className, dataTestId, theme, backgroundShape } = props;
    const wrapperClassNames = getClassNameList$6('calendar-rates-background', {
        'calendar-rates-background-flat': theme === 'default' || backgroundShape === 'flat',
    }, {
        'calendar-rates-background-rounded': backgroundShape === 'rounded',
    }, { 'calendar-rates-background-circle': backgroundShape === 'circle' }, CalendarRatesBackgroundThemes.get(theme), className);
    return (jsx("div", { className: wrapperClassNames, "data-test-id": dataTestId, children: children }));
};
CalendarRatesBackground.displayName = 'CalendarRatesBackground';

const getClassNameList$5 = classNames$5.bind(styles$b);
const Carousel = ({ children, extraPeekWidth = false, zoomAnimationOnHover = false, carouselFullHeight = false, ...props }) => {
    const carouselClassName = getClassNameList$5({
        'carousel-extra-peek': extraPeekWidth,
        'zoom-animation-on-hover': zoomAnimationOnHover,
        'carousel-full-height': carouselFullHeight,
    });
    return (jsx(EGDSCarousel, { className: carouselClassName, ...props, children: children }));
};
Carousel.displayName = 'LodgingCarousel';

const getClassNameList$4 = classNames$5.bind(styles$c);
const Card = ({ children, addBorderOnHover = false, removeRoundedCorner = false, addDropShadow = false, className, ...props }) => {
    const cardClassName = getClassNameList$4({
        'add-border-on-hover': addBorderOnHover,
        'uitk-card-unset-roundcorner-all': removeRoundedCorner,
        'drop-shadow': addDropShadow,
    }, className);
    return (jsx(EGDSCard, { className: cardClassName, ...props, children: children }));
};
Card.displayName = 'LodgingCard';

classNames$5.bind(styles$d);
const coachMarkPositionTuples = [
    ['top', 'coach-mark-3--top-left'],
    ['top-right', 'coach-mark-3--top-right'],
    ['top-left', 'coach-mark-3--top-left'],
    ['bottom', 'coach-mark-3--bottom-right'],
    ['bottom-right', 'coach-mark-3--bottom-right'],
    ['bottom-left', 'coach-mark-3--bottom-left'],
];
const coachMarkThemeTuples = [
    ['bex-bright-theme', 'coach-mark-3--bex-bright-theme'],
    ['hcom-blue-theme', 'coach-mark-3--hcom-blue-theme'],
];
const coachMarkStandardStyles = {
    inline: 'three',
    blockstart: 'one',
    blockend: 'six',
    justifyContent: 'center',
    direction: 'column',
    alignSelf: 'end',
};
const coachMarkSlimStyles = {
    inline: 'one',
    blockstart: 'one',
    blockend: 'one',
    justifyContent: 'start',
    direction: 'row-reverse',
    alignSelf: 'start',
};
const coachMarkPositions = new Map(coachMarkPositionTuples);
const coachMarkThemes = new Map(coachMarkThemeTuples);
const setCoachMarkPosition = (position, slim) => {
    let standardPostion = coachMarkPositions.get(position) || '';
    if (slim && standardPostion.includes('right')) {
        standardPostion = standardPostion.replace('right', 'right-slim');
    }
    return standardPostion;
};
const setCoachMarkAnimation = (animation, useReducedMotion) => {
    if (animation) {
        return useReducedMotion ? 'coach-mark-3--has-reduced-motion' : 'coach-mark-3--animation';
    }
    return '';
};
const CoachMark3 = ({ onDismiss, animation = false, position, theme = 'hcom-blue-theme', slim = false, children, }) => {
    const coachMarkRef = React__default.useRef(null);
    const useReducedMotion = window ? window.matchMedia(`(prefers-reduced-motion: reduce)`).matches : false;
    const coachMarkSlim = slim ? 'coach-mark-3--slim' : '';
    const coachMarkPosition = setCoachMarkPosition(position, slim);
    const coachMarkAnimation = setCoachMarkAnimation(animation, useReducedMotion);
    const coachMarkClassNames = `coach-mark-3 ${coachMarkSlim} ${coachMarkPosition} ${coachMarkThemes.get(theme) || ''} ${coachMarkAnimation}`;
    const coachMarkStyles = slim ? coachMarkSlimStyles : coachMarkStandardStyles;
    const handleClick = () => {
        if (animation) {
            coachMarkRef.current.classList.add('dismiss-coachmark');
            Promise.all(coachMarkRef.current.getAnimations().map((animate) => animate.finished)).then(() => onDismiss());
        }
        else {
            onDismiss();
        }
    };
    return (jsx("div", { className: `${coachMarkClassNames}`, ref: coachMarkRef, children: jsx(EGDSSpacing, { padding: {
                inline: coachMarkStyles.inline,
                blockstart: coachMarkStyles.blockstart,
                blockend: coachMarkStyles.blockend,
            }, children: jsxs(EGDSLayoutFlex, { justifyContent: coachMarkStyles.justifyContent, direction: coachMarkStyles.direction, children: [jsx(EGDSLayoutFlexItem, { alignSelf: coachMarkStyles.alignSelf, children: jsx(EGDSTertiaryButton, { onClick: handleClick, type: "button", className: animation && !useReducedMotion ? 'coach-mark-3__dismiss-btn--animation' : 'coach-mark-3__dismiss-btn', "aria-label": "close", children: jsx(EGDSIcon, { id: "icon__close", name: "icon__close", theme: "inverse" }) }) }), jsx(EGDSLayoutFlexItem, { className: animation && !useReducedMotion ? 'coach-mark-3__content--animation' : '', children: jsx("div", { children: children || null }) })] }) }) }));
};
CoachMark3.displayName = 'CoachMark3';

const CoachMark3SlimContent = ({ text, showIcon, iconUrl = 'https://a.travel-assets.com/travel-assets-manager/pictogram-bex/coachmark__light__find_price.svg', }) => (jsx(EGDSSpacing, { padding: { inline: 'two', blockstart: 'two', blockend: 'two' }, children: jsxs(EGDSLayoutFlex, { direction: "row", space: "small", children: [showIcon && (jsx(EGDSLayoutFlexItem, { shrink: 0, children: jsx("div", { className: "coach-mark-3__image", children: jsx(EGDSFigure, { ratio: EGDSFigureAspectRatioType.R1_1, children: jsx(EGDSImage, { src: iconUrl, alt: "pictogram" }) }) }) })), jsx(EGDSLayoutFlexItem, { children: jsx(EGDSText, { theme: "light", size: 300, weight: "medium", spacing: "two", children: text }) })] }) }));

const CoachMark3StandardContent = ({ title, subtitle, showIcon, iconUrl = 'https://a.travel-assets.com/travel-assets-manager/pictogram-bex/coachmark__light__find_price.svg', }) => (jsxs(EGDSLayoutFlex, { direction: "column", children: [showIcon && (jsx(EGDSLayoutFlexItem, { alignSelf: "center", children: jsx(EGDSSpacing, { padding: { blockend: 'two' }, children: jsx("div", { children: jsx("div", { className: "coach-mark-3__image", children: jsx(EGDSFigure, { ratio: EGDSFigureAspectRatioType.R1_1, children: jsx(EGDSImage, { src: iconUrl, alt: "pictogram" }) }) }) }) }) })), jsx(EGDSLayoutFlexItem, { children: jsx(EGDSText, { theme: "light", size: 400, weight: "medium", children: title }) }), jsx(EGDSLayoutFlexItem, { children: jsx(EGDSText, { theme: "light", size: showIcon ? 300 : 400, weight: "regular", children: subtitle }) })] }));

const getClassNameList$3 = classNames$5.bind(styles$e);
const baseClassName$1 = 'range-indicator';
const EGDSLocalRangeIndicatorPinComponent = ({ percentage, key, badge, segmentNumber, }) => {
    const badgeRef = useRef(null);
    const trackRef = useRef(null);
    useEffect(() => {
        if (badgeRef?.current && trackRef?.current) {
            const badgeOffset = badgeRef.current.getBoundingClientRect().width / 2;
            const trackWidth = trackRef.current.parentElement.getBoundingClientRect().width;
            const leftEndTrackOffset = (percentage / 100) * trackWidth;
            const rightEndTrackOffset = ((100 - percentage) / 100) * trackWidth;
            const shouldOverridePositionLeftEnd = segmentNumber === 0 && leftEndTrackOffset < badgeOffset;
            const shouldOverridePositionRightEnd = segmentNumber > 0 && rightEndTrackOffset < badgeOffset;
            trackRef.current.style.insetInlineStart = `calc(${percentage}% - ${badgeOffset}px + var(--uitk-layoutgrid-egds-size__1x))`;
            if (shouldOverridePositionLeftEnd) {
                badgeRef.current.style.transform = `translateX(calc(${badgeOffset}px - ${leftEndTrackOffset}px - var(--uitk-layoutgrid-egds-size__1x)))`;
            }
            if (shouldOverridePositionRightEnd) {
                badgeRef.current.style.transform = `translateX(calc(${ -1 * badgeOffset}px + ${rightEndTrackOffset}px + var(--uitk-layoutgrid-egds-size__1x)))`;
            }
        }
    });
    return (jsxs("div", { "aria-hidden": "true", className: getClassNameList$3(`${baseClassName$1}-indicator`), ref: trackRef, children: [jsx("div", { className: getClassNameList$3(`${baseClassName$1}-badge`), ref: badgeRef, children: jsx(EGDSBadgeStandard, { text: badge.text, theme: "emphasis", size: "large" }) }), jsx(EGDSIcon, { className: getClassNameList$3(`${baseClassName$1}-dot`), name: "circle_filled", size: EGDSIconSize.EXTRA_SMALL })] }, key));
};

const EGDSLocalRangeIndicatorMilestoneWeightMap = [
    ['REGULAR', 'regular'],
    ['MEDIUM', 'medium'],
    ['BOLD', 'bold'],
];
const EGDSLocalRangeIndicatorMilestoneWeights = new Map(EGDSLocalRangeIndicatorMilestoneWeightMap);
const EGDSLocalRangeIndicatorSegmentStyleMap = [['EMPHASIS', 'EMPHASIS']];
const EGDSLocalRangeIndicatorSegmentStyles = new Map(EGDSLocalRangeIndicatorSegmentStyleMap);
const EGDSLocalRangeIndicatorSegmentThemeMap = [
    ['NEGATIVE', 'negative'],
    ['NEUTRAL', 'neutral'],
    ['POSITIVE', 'positive'],
    ['VERY_POSITIVE', 'very-positive'],
];
const EGDSLocalRangeIndicatorSegmentThemes = new Map(EGDSLocalRangeIndicatorSegmentThemeMap);

const getClassNameList$2 = classNames$5.bind(styles$e);
const EGDSLocalRangeIndicator = ({ accessibility, className, milestones, segments, }) => {
    const baseClassName = 'range-indicator';
    const emphasis = EGDSLocalRangeIndicatorSegmentStyles.get('EMPHASIS');
    const colSpan = segments.map(({ style }) => (style === emphasis ? 4 : 2));
    const columns = colSpan.reduce((acc, val) => acc + val, 0);
    return (jsxs("figure", { "aria-label": accessibility, className: getClassNameList$2(baseClassName, className), role: "figure", children: [accessibility && jsx("figcaption", { className: "is-visually-hidden", children: accessibility }), jsxs(EGDSLayoutGrid, { className: getClassNameList$2(`${baseClassName}-grid`), columns: columns, children: [segments.map(({ pins, theme }, index) => (jsx(EGDSLayoutGridItem, { colSpan: colSpan[index], children: jsx("div", { className: getClassNameList$2(`${baseClassName}-segment`, {
                                [`${baseClassName}-segment__${EGDSLocalRangeIndicatorSegmentThemes.get(theme)}`]: theme,
                            }), children: pins &&
                                pins.map(({ percentage, badge }, key) => (jsx(EGDSLocalRangeIndicatorPinComponent, { badge: badge, percentage: percentage, segmentNumber: index + 1 === segments.length || index === 0 ? index : null }, key))) }) }, index))), milestones.slice(0, colSpan.length - 1).map(({ label }, index) => {
                        const { text, weight } = label;
                        const colStart = colSpan.slice(0, index + 1).reduce((acc, value) => acc + value, 0);
                        return (jsx(EGDSLayoutGridItem, { colStart: colStart, colEnd: colStart + 2, children: jsx(EGDSText, { "aria-hidden": "true", align: "center", size: 200, weight: EGDSLocalRangeIndicatorMilestoneWeights.get(weight), children: text }) }, index));
                    })] })] }));
};
EGDSLocalRangeIndicator.displayName = 'EGDSLocalRangeIndicator';

const classNames$4 = classNames$5.bind(styles$f);
const expandoBaseClassName = 'expando-bottom-sheet';
const widthBaseClassName = 'centered-sheet-width';
const splitViewBaseClassName = 'split-view';
const dimensionsChangeBaseClassName = 'dimensions-change';
const extendedHeightClassName = 'extended-sheet-height';
const pixelsToEgdsSizing$1 = (pixels) => `${Math.round(pixels / 4) / 4}rem`;
const defaultColumns = {
    large: [MinMax('660px', '800px'), MinMax('332px', '400px')],
    extra_large: [MinMax('680px', '864px'), MinMax('520px', '1fr')],
};
const getDimensions = (element) => element ? element.getBoundingClientRect() : new DOMRect();
const Sheet = ({ className, children, transition, tall, expanded, minWidth, maxWidth, splitView, columns = defaultColumns, onDimensionsChange, extendedHeight, ...props }) => {
    const isExpando = props.type === 'bottom' && typeof expanded === 'boolean';
    const hasWidth = props.type === 'centered' && Boolean(minWidth || maxWidth);
    const classes = classNames$4(className, {
        'sheet-tall': props.type === 'bottom' && tall,
        [`${expandoBaseClassName}-collapsed`]: isExpando && !expanded,
        [widthBaseClassName]: hasWidth,
        'split-view-sheet': splitView,
        [extendedHeightClassName]: props.type === 'bottom' && extendedHeight,
    });
    const widthStyle = useMemo(() => {
        if (!hasWidth) {
            return undefined;
        }
        return {
            ...(minWidth ? { '--centered-sheet-width-min-size': pixelsToEgdsSizing$1(minWidth) } : {}),
            ...(maxWidth ? { '--centered-sheet-width-max-size': pixelsToEgdsSizing$1(maxWidth) } : {}),
        };
    }, [minWidth, maxWidth]);
    const ref = useRef(null);
    const handleRef = useCallback((element) => {
        ref.current = element;
        onDimensionsChange?.(getDimensions(element));
    }, [onDimensionsChange]);
    const { openCallback, closeCallback } = transition ?? {};
    const handleOpen = useCallback(() => {
        requestAnimationFrame(() => {
            onDimensionsChange?.(getDimensions(ref.current));
        });
        openCallback?.();
    }, [openCallback, onDimensionsChange]);
    const handleClose = useCallback(() => {
        requestAnimationFrame(() => {
            onDimensionsChange?.(getDimensions(ref.current));
        });
        closeCallback?.();
    }, [closeCallback, onDimensionsChange]);
    const handleExpandoTransition = useCallback(() => {
        onDimensionsChange?.(getDimensions(ref.current));
    }, [onDimensionsChange]);
    useEffect(() => {
        if (onDimensionsChange) {
            const handleResize = () => {
                onDimensionsChange?.(getDimensions(ref.current));
            };
            window.addEventListener('resize', handleResize);
            return () => window.removeEventListener('resize', handleResize);
        }
    }, [onDimensionsChange]);
    let sheet = (jsx(EGDSSheet, { ...props, className: classes, children: children }));
    if (transition) {
        sheet = (jsx(EGDSSheetTransition, { ...transition, openCallback: handleOpen, closeCallback: handleClose, children: sheet }));
    }
    if (isExpando) {
        sheet = (jsx(CSSTransition, { in: expanded, timeout: 300, classNames: {
                enter: classNames$4(`${expandoBaseClassName}-enter`),
                enterActive: classNames$4(`${expandoBaseClassName}-enter-active`),
                exit: classNames$4(`${expandoBaseClassName}-exit`),
                exitActive: classNames$4(`${expandoBaseClassName}-exit-active`),
            }, appear: false, onEntered: handleExpandoTransition, onExited: handleExpandoTransition, children: sheet }));
    }
    if (hasWidth) {
        sheet = (jsx("div", { style: widthStyle, className: `${widthBaseClassName}-provider`, children: sheet }));
    }
    if (onDimensionsChange) {
        sheet = (jsx("div", { className: dimensionsChangeBaseClassName, ref: handleRef, children: sheet }));
    }
    if (splitView) {
        sheet = (jsx("div", { className: splitViewBaseClassName, children: jsxs(EGDSLayoutGrid, { columns: columns, className: `${splitViewBaseClassName}-grid`, children: [jsx(EGDSLayoutGridItem, { className: `${splitViewBaseClassName}-grid-item`, children: jsx("div", { children: sheet }) }), jsx(EGDSLayoutGridItem, { children: jsx("div", {}) })] }) }));
    }
    return sheet;
};

const classNames$3 = classNames$5.bind(styles$g);
const baseClassName = 'card-thumbnail';
const ThumbnailCard = ({ children, className, placeholder, imageUrl, ...props }) => {
    const classes = classNames$3(baseClassName, { 'uitk-card-has-placeholder-border': placeholder }, className);
    return (jsx(EGDSCard, { className: classes, ...props, children: imageUrl ? (jsx(EGDSFigure, { src: imageUrl, imageFit: "cover", children: children })) : (children) }));
};
ThumbnailCard.displayName = 'ThumbnailCard';

const classNames$2 = classNames$5.bind(styles$h);
const Toolbar = ({ bottomBorder, inverse, className, ...props }) => {
    const { navType } = props.navigationContent ?? {};
    const expandNavigation = navType === 'expand_down' || navType === 'expand_up';
    const classes = classNames$2(className, 'lodging-toolbar', {
        'toolbar-border-bottom': bottomBorder,
        'toolbar-inverse': inverse,
        'toolbar-no-navigation': !props.navigationContent,
        'toolbar-expand-navigation': expandNavigation,
    });
    return (jsx(EGDSToolbar, { ...props, className: classes, children: expandNavigation && (jsx(EGDSLayoutPosition, { onClick: props.navigationContent?.onClick, type: "absolute", position: { top: 'zero', left: 'twelve', right: 'zero', bottom: 'zero' }, cloneElement: true, children: jsx("div", {}) })) }));
};

const classNames$1 = classNames$5.bind(styles$i);
const TableRow = (props) => {
    const { spotlightRow, className } = props;
    const classes = classNames$1(className, {
        'table-row-spotlight-row': spotlightRow,
    });
    return jsx(EGDSTableRow, { className: classes, ...props });
};

const classNames = classNames$5.bind(styles$j);
const pixelsToEgdsSizing = (pixels) => `${Math.round(pixels / 4) / 4}rem`;
const styleMap = {
    startstart: {
        variable: '--lodging-figure-start-start-border-radius',
        className: 'lodging-figure-border-start-start-radius',
    },
    startend: {
        variable: '--lodging-figure-start-end-border-radius',
        className: 'lodging-figure-border-start-end-radius',
    },
    endstart: {
        variable: '--lodging-figure-end-start-border-radius',
        className: 'lodging-figure-border-end-start-radius',
    },
    endend: { variable: '--lodging-figure-end-end-border-radius', className: 'lodging-figure-border-end-end-radius' },
};
const Figure = ({ children, borderRadius, className, ...props }) => {
    const { style, classes } = useMemo(() => {
        if (!borderRadius) {
            return {};
        }
        if (typeof borderRadius === 'number' || typeof borderRadius === 'string') {
            return {
                style: {
                    '--lodging-figure-border-radius': typeof borderRadius === 'number' ? pixelsToEgdsSizing(borderRadius) : borderRadius,
                },
                classes: ['lodging-figure-border-radius'],
            };
        }
        const definedEntries = Object.entries(borderRadius).filter(([, value]) => value !== undefined);
        return {
            style: Object.fromEntries(definedEntries.map(([key, value]) => [
                styleMap[key].variable,
                typeof value === 'number' ? pixelsToEgdsSizing(value) : value,
            ])),
            classes: definedEntries.map(([key]) => styleMap[key].className),
        };
    }, [borderRadius]);
    return (jsx(EGDSFigure, { style: style, className: classNames(className, classes), ...props, children: children }));
};
Figure.displayName = 'LodgingFigure';

const getClassNameList$1 = classNames$5.bind(styles$k);
const SegmentedControlItem = ({ ariaLabel, className, controlContainerName, disabled = false, icon, id, labelOverflow, onClick, selected = false, title, value, }) => {
    const baseClass = 'lodging-segmented-control-item';
    const wrapperClasses = getClassNameList$1(baseClass, className, {
        [`${baseClass}--selected`]: selected,
        [`${baseClass}--disabled`]: disabled,
    });
    const handleClick = () => {
        onClick?.(value);
    };
    return (jsxs("label", { className: wrapperClasses, htmlFor: id, children: [jsx("input", { type: "radio", name: controlContainerName, id: id, checked: selected, className: `${baseClass}__input`, onChange: handleClick, value: value, disabled: disabled, "aria-label": ariaLabel, "aria-checked": selected, "aria-disabled": disabled }), jsxs(EGDSLayoutFlex, { space: "small", alignItems: "center", justifyContent: "center", children: [icon?.name && (jsx(EGDSIcon, { className: `${baseClass}__icon`, name: icon.name, size: EGDSIconSize.SMALL, ...icon })), title && (jsx(EGDSText, { "aria-hidden": "true", weight: "medium", overflow: labelOverflow, children: title }))] })] }));
};

const getClassNameList = classNames$5.bind(styles$k);
const INTERACTION_TIMER = 200; // Interaction Timer of resize handler
const SegmentedControls = ({ className, domRef, items, itemsWidth = 'equal', name, onSegmentSelection, selectedItemId, ...attributes }) => {
    const itemsWrapperRef = React__default.useRef(null);
    const selectionBackgroundRef = React__default.useRef(null);
    const [windowWidth, setWindowWidth] = React__default.useState(0);
    const baseClass = 'lodging-segmented-controls';
    const radiogroupClasses = getClassNameList(baseClass, className, `${baseClass}--${itemsWidth}-width-items`);
    const controlItems = items?.map((item, index) => (jsx(SegmentedControlItem, { ...item, controlContainerName: name, labelOverflow: itemsWidth === 'equal' ? 'truncate' : undefined, onClick: () => {
            onSegmentSelection(item);
            item.onClick?.(item.value);
        }, selected: item.id === selectedItemId }, `${name}-item-${index}`)));
    const selectedItemIndex = React__default.useMemo(() => {
        if (items?.length > 0) {
            const index = items.findIndex((item) => item.id === selectedItemId);
            // Return the found index, or 0 if not found to avoid runtime errors
            return index > 0 ? index : 0;
        }
        return 0; // Default to first item if no children
    }, [selectedItemId, items]);
    const updateBackgroundPosition = () => {
        const controlChildren = itemsWrapperRef.current?.children;
        const selectedChild = controlChildren[selectedItemIndex];
        const selectedItemDimensions = selectedChild?.getBoundingClientRect();
        const backgroundElement = selectionBackgroundRef.current;
        if (backgroundElement && selectedItemDimensions) {
            backgroundElement.style.width = `${selectedItemDimensions.width}px`;
            backgroundElement.style.height = `${selectedItemDimensions.height}px`;
            const isRtl = document.documentElement.querySelector('html')?.getAttribute('dir') === 'rtl';
            const selectedItemNode = selectedChild;
            const parentWidth = selectedItemNode.offsetParent?.clientWidth ?? 0;
            const itemsPadding = controlChildren[isRtl ? controlChildren.length - 1 : 0].offsetLeft;
            const offsetLeft = selectedItemNode.offsetLeft - itemsPadding;
            const offsetRight = -(parentWidth - selectedItemNode.offsetLeft - selectedItemNode.offsetWidth) + itemsPadding;
            const backgroundElementOffset = isRtl ? offsetRight : offsetLeft;
            backgroundElement.style.transform = `translateX(${backgroundElementOffset}px)`;
        }
    };
    React__default.useEffect(() => {
        if (window) {
            setWindowWidth(window.innerWidth);
            const debounceResizeHandler = debounce(INTERACTION_TIMER, () => {
                if (windowWidth === window.innerWidth) {
                    return;
                }
                setWindowWidth(window.innerWidth);
            });
            window.addEventListener('resize', debounceResizeHandler);
            return () => window.removeEventListener('resize', debounceResizeHandler);
        }
    }, []);
    const useEnhancedEffect = typeof window === 'undefined' ? React__default.useEffect : React__default.useLayoutEffect;
    useEnhancedEffect(() => {
        updateBackgroundPosition();
    }, [selectedItemIndex, windowWidth]);
    return (jsxs("div", { role: "radiogroup", className: radiogroupClasses, ref: domRef, "aria-label": name, ...attributes, children: [jsx("div", { className: `${baseClass}__group`, ref: itemsWrapperRef, children: controlItems }), jsx("div", { className: `${baseClass}__selection-background`, ref: selectionBackgroundRef })] }));
};
SegmentedControls.displayName = 'SegmentedControls';

export { CalendarRatesBackground, Card, Carousel, CoachMark3, CoachMark3SlimContent, CoachMark3StandardContent, EGDSIconLoyaltyThemes, EGDSLocalNeutralColorLink, EGDSLocalRangeIndicator, EGDSTextLoyaltyThemes, Figure, IconLoyaltyThemes, LoyaltyBadgeMuted, PriceNumberInput, PriceSlider, RadioButtonDescriptionExtensionWithPositiveTheme, RadioButtonDescriptionExtensionWithPositiveThemeGroup, RadioButtonDescriptionExtensionWithPositiveThemeGroupContext, SegmentedControls, Sheet, SliderTextInputs, StepIndicator, TableRow, TertiaryButtonLargeIcon, TextLoyaltyThemes, ThumbnailCard, Toolbar, EGDSIconLoyaltyThemes as UitkIconLoyaltyThemes, EGDSTextLoyaltyThemes as UitkTextLoyaltyThemes };
//# sourceMappingURL=index.esm.js.map
